export default {
    header: {
        title: '守云科技',
        home: '首页',
        feature: '零信任科技',
        service: '服务',
        about: '关于',
        contact: '联系我们',
    },
    main: {
        home: {
            title: '安全 & 优化 零信任网络',
            subtitle1: '无论何时何地都能安全地访问私有数据',
            subtitle2: '更安全、高可用和性能更好的零信任访问解决方案取代传'
        },
        feature: {
            title: 'SOGATE - 零信任网络',
            subtitle1: '验证、过滤、隔离、检查、覆盖您管理的所有设备，甚至您没有管理的设备。',
            subtitle2: '您的员工、合作伙伴和客户需要安全、快速、可靠的网络来完成工作。利用我们的全球边缘网络取代了传统的安全边界，从而为世界各地的团队提供更快、更安全的互联网。',
            list1: {
                title: '保护所有应用',
                subtitle1: '与身份和来源均无关，让您能够保护任何应用程序，不论是 SaaS、云还是本地应用程序。',
                subtitle2: '使用 IP 防火墙和 Zero Trust 规则，甚至对传统应用程序也能实施严格、一致的身份认证方法。',
            },
            list2: {
                title: '阻止互联网上的已知或未知威胁',
                subtitle1: '阻止对已知的恶意、危险或有害目的地的访问。',
                subtitle2: '基于安全性、内容和应用程序的分类使得构建策略和审计安全性或遵从性事件变得轻而易举。',
            },
            list3: {
                title: '为IT管理员构建',
                subtitle1: '易于安装，快速部署，无需更改基础设施。',
                subtitle2: '简化行政工作负载，通过一个管理控制台集中管理访问。',
                subtitle3: '性能和可靠性， 通过分离隧道和消除回程的智能路由来减少网络负担。自动管理负载平衡、冗余和扩展。',
            },
            list4: {
                title: '零信任访问',
                subtitle1: '即使用户进行了身份验证，他们也只能访问您提供给他们的资源——这限制了攻击的潜在爆炸半径。',
            }
        },
        service: {
            title: '服务',
            subtitle: '借助性能最佳的 Zero Trust 应用程序访问和互联网浏览解决方案，阻止数据丢失、恶意软件和网络钓鱼。',
            list1: '您的网络对internet是不可见的，这大大减少了机会主义攻击的风险。',
            list2: '在网络钓鱼和恶意软件发动攻击前加以阻止，并在遭入侵设备导致破坏前加以遏制。',
            list3: '将来自企业设备（支持 Windows、Mac、iOS 和 Android 客户端）的流量指向 ZTN。',
            list4: '附带策略构建器的流量检查，提供过滤数据流的高级控制。',
            list5: '对所有 SaaS 和自托管应用程序——云、混合云或本地——执行一致、基于角色的访问控制。',
            list6: '通过在全球分布、可抵御 DDoS 攻击的边缘网络上部署的 ZTNA，加速远程访问并降低对 VPN 的依赖。',
        },
        about: {
            title: '关于',
            subtitle1: '在当今严峻的网络安全形势下，用户需要能够在任何地点、通过任何设备访问资源。保护您的“随时随地办公”团队的同时又不损害用户体验， 这一点至关重要。我们 sogate.net 公司为您提供了一套完整的产品组合，以确保实现：对私有应用程序、云服务和网站的安全、 可靠、零信任连接。',
            subtitle2: 'SoGate 是一款易于使用的基于云的零信任网络访问（ZTNA）解决方案，它能够提供高性能、安全且可靠的远程访问服务， 无论是本地应用还是云端 资源均可适用。此外，该方案还能确保统一的策略执行，并能有效抵御高级网络威胁，同时不会影响性能。',
        },
        contact: {
            title: '联系我们',
            address: '地址',
            address_value: '广州市天河区天河路621号1001房',
            email: '邮箱',
            phone: '电话',
        }
    },
    footer: {
        copyright: '版权 © {year} 广州守云科技有限公司 · 版权所有',
    }
}